import { enableAnalytics } from './analytics';

const STORAGE_KEY = 'fyle-consent';

type ConsentValue = 'accepted' | 'declined';
type ConsentState = ConsentValue | 'unknown';

let consentState: ConsentState = 'unknown';
let initialized = false;

const listeners = new Set<(state: ConsentState) => void>();

const notify = () => {
  listeners.forEach((listener) => listener(consentState));
};

const readStoredConsent = (): ConsentState => {
  if (typeof window === 'undefined') {
    return 'unknown';
  }

  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'accepted' || stored === 'declined') {
    return stored;
  }

  return 'unknown';
};

const persistConsent = (value: ConsentValue) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, value);
};

export const initializeConsent = () => {
  if (initialized) {
    return consentState;
  }

  initialized = true;
  consentState = readStoredConsent();

  if (consentState === 'accepted') {
    enableAnalytics();
  }

  notify();
  return consentState;
};

export const getConsentState = (): ConsentState => consentState;

export const setConsentState = (value: ConsentValue) => {
  initializeConsent();
  consentState = value;
  persistConsent(value);

  if (consentState === 'accepted') {
    enableAnalytics();
  }

  notify();
};

export const resetConsent = () => {
  initializeConsent();
  consentState = 'unknown';

  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(STORAGE_KEY);
  }

  notify();
};

export const subscribeToConsent = (listener: (state: ConsentState) => void) => {
  listeners.add(listener);
  listener(consentState);
  return () => {
    listeners.delete(listener);
  };
};


